import { SET_IT_CLOUD_SELECTED_OPTION, RESET_IT_CLOUD_SELECTED_OPTION } from '../actions/philipsITAction';

const initialState = {
    selectedOption: null,
    isOptionSelected: false,
};

const philipsITReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IT_CLOUD_SELECTED_OPTION:
            return {
                ...state,
                selectedOption: action.payload,
                isOptionSelected: true,
            };
        case RESET_IT_CLOUD_SELECTED_OPTION:
            return {
                ...state,
                selectedOption: null,
                isOptionSelected: false,
            };
        default:
            return state;
    }
};

export default philipsITReducer;
